export const SET_RECEIPT = 'SET_RECEIPT'

export const setReceipt = (receipt) => ({
  type: SET_RECEIPT,
  receipt,
})
